import { Dispatch } from 'redux';
import { replace } from 'connected-react-router';
import api from '@src/util/api';
import { LocalStorageKeys } from '@src/enums/localStorageKeys.enum';
import apolloClient from '@src/graphql/apollo';
import { LOGIN_ROUTE } from '@src/Routes/links';
import { captureError } from '@src/util/error';
import { logout } from './recruiter';
import { resetStore } from './main';

export const ACCESS_TOKEN_SET = `${__dirname}/accessTokenSet`;
export function setAccessToken(accessToken) {
  localStorage.setItem(LocalStorageKeys.TOKEN_STORAGE_KEY, accessToken);

  return {
    accessToken: accessToken,
    type: ACCESS_TOKEN_SET,
  };
}

export const ACCESS_TOKEN_REMOVE = `${__dirname}/accessTokenRemove`;
export function removeAccessToken() {
  return async dispatch => {
    localStorage.removeItem(LocalStorageKeys.TOKEN_STORAGE_KEY);

    apolloClient.stop();
    await apolloClient.clearStore();

    dispatch({
      accessToken: null,
      type: ACCESS_TOKEN_REMOVE,
    });

    dispatch(resetStore());
    dispatch(replace({ pathname: LOGIN_ROUTE, search: '' }));
  };
}

export function fetchRefreshToken() {
  return async (dispatch: Dispatch): Promise<string | undefined> => {
    try {
      const { accessToken } = await api<{ accessToken: string }>('/api/token/refresh');
      dispatch(setAccessToken(accessToken));

      return accessToken;
    } catch (error) {
      captureError(error);

      dispatch(logout());

      return undefined;
    }
  };
}

export function fetchAccessToken() {
  return async (dispatch: Dispatch): Promise<string> => {
    try {
      const { accessToken } = await api<{ accessToken: string }>('/api/token');
      dispatch(setAccessToken(accessToken));

      return accessToken;
    } catch (error) {
      captureError(error);

      if (error.code === 401) {
        return dispatch(fetchRefreshToken());
      }

      return '';
    }
  };
}
